var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_1203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 49.9375H3.1875C2.01875 49.9375 1.0625 48.9813 1.0625 47.8125V3.1875C1.0625 2.01875 2.01875 1.0625 3.1875 1.0625H31.4394C32.0025 1.0625 32.5444 1.28563 32.9375 1.68938L40.8106 9.5625C41.2144 9.95563 41.4375 10.4975 41.4375 11.0606V18.0625M20.2512 32.9375C14.6625 32.9587 9.99812 28.645 9.605 23.0669C9.21187 17.4887 13.1962 12.5588 18.7425 11.7831C24.2781 11.0181 29.4737 14.6731 30.6106 20.145M20.1875 15.9375V22.3125H24.4375M40.375 30.8125H36.0506C34.68 30.8125 33.5112 31.7794 33.2562 33.1181C33.0012 34.4569 33.7238 35.7956 34.9881 36.3056L39.3763 38.0587C40.6513 38.5687 41.3738 39.9075 41.1188 41.2462C40.8638 42.585 39.6844 43.5625 38.3138 43.5519H34M37.1875 45.6875V43.5625M37.1875 30.8125V28.6875M24.4375 37.1875C24.4375 44.2319 30.1431 49.9375 37.1875 49.9375C44.2319 49.9375 49.9375 44.2319 49.9375 37.1875C49.9375 30.1431 44.2319 24.4375 37.1875 24.4375C30.1431 24.4375 24.4375 30.1431 24.4375 37.1875Z",
    stroke: "#00FD8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_1203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon6);
export default __webpack_public_path__ + "static/media/cardicon6.2b50dce507173fa9fce926c31c678529.svg";
export { ForwardRef as ReactComponent };